import receptionApi from '@/api/account';

const state = {
    isLoading: false,
    validationErrors: null,
    isSubmitting: false,
    data:null
}

export const mutationTypes = {
    makePaymentStart: '[account] Make payment start',
    makePaymentSuccess: '[account] Make payment success',
    makePaymentFailure: '[account] Make payment failure',
}

export const accountActionTypes = {
    makePayment: '[account] Make payment',
}

const mutations = {
    [mutationTypes.makePaymentStart](state) {
        state.isLoading = true
        state.listVisitor = null
    },
    [mutationTypes.makePaymentSuccess](state, payload) {
        state.isLoading = false
        state.data = payload
        state.validationErrors = null
    },
    [mutationTypes.makePaymentFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },

}

const actions = {
    [accountActionTypes.makePayment](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.makePaymentStart)
            receptionApi
                .makePayment(data)
                .then(response => {
                    context.commit(mutationTypes.makePaymentSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.makePaymentFailure,response)
                })
        })
    },
}

export default {
    state,
    actions,
    mutations
}